import React, { useEffect, Fragment } from "react";
import { useLocation } from "react-router-dom";

interface IProps {
  children: React.ReactNode;
}

function ScrollToTopPage({ children }: IProps) {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return <Fragment>{children}</Fragment>;
}

export default ScrollToTopPage;
